import { render, staticRenderFns } from "./detrusion.vue?vue&type=template&id=f0f95412&scoped=true"
import script from "./detrusion.vue?vue&type=script&lang=js"
export * from "./detrusion.vue?vue&type=script&lang=js"
import style0 from "./detrusion.vue?vue&type=style&index=0&id=f0f95412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f95412",
  null
  
)

export default component.exports